import API from '../../API';
import {
  fetchProfileFailureActionCreator,
  fetchProfileRequestActionCreator,
  fetchProfileSuccessActionCreator,
  followProfileFailureActionCreator,
  followProfileRequestActionCreator,
  followProfileSuccessActionCreator,
  sendMessageFailureActionCreator,
  sendMessageRequestActionCreator,
  sendMessageSuccessActionCreator,
} from './profile.actionCreators';

export const fetchProfile = id => {
  return async dispatch => {
    dispatch(fetchProfileRequestActionCreator());
    return await API.get(`/profiles/${id}`)
      .then(resp => {
        dispatch(fetchProfileSuccessActionCreator(resp));

        return resp;
      })
      .catch(err => {
        dispatch(fetchProfileFailureActionCreator(err));
        throw err;
      });
  };
};
export const fetchProfileSubInfo = id => {
  return async dispatch => {
    return await API.get(`/profiles/${id}/follow`)
      .then(resp => {

        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const fetchProfileSubs = id => {
  return async dispatch => {
    return await API.get(`/users/${id}/subscribe-details`)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        dispatch(fetchProfileFailureActionCreator(err));
        throw err;
      });
  };
};
export const toggleFollow = id => {
  return async dispatch => {
    dispatch(followProfileRequestActionCreator());

    return await API.post(`/profiles/${id}/follow`)
      .then(resp => {
        dispatch(followProfileSuccessActionCreator(resp));

        return resp;
      })
      .catch(err => {
        dispatch(followProfileFailureActionCreator(err));
        throw err;
      });
  };
};
export const sendRedNotification = id => {
  return async dispatch => {
    return await API.post(`notifications/${id}/mark-vendor-read`)
      .then(resp => {

        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const sendFollowDecide = (id,param) => {
  return async dispatch => {
    return await API.post(`profiles/${id}/follow-decide`,{action:param})
      .then(resp => {

        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const sendMessageAction = (id, params) => {
  console.log('send message', id, params);

  return async dispatch => {
    dispatch(sendMessageRequestActionCreator());
    return await API.post(`/contact`, params, true)
      .then(resp => {
        dispatch(sendMessageSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(sendMessageFailureActionCreator());
        throw err;
      });
  };
};
